<template>
  <div class="blog-dashboard">
    <h1 class="pt-4">
      Our blog
    </h1>
    <tml-loader :loading="!loaded" height="50vh" text="Loading...">
      <blog-dashboard-layout
        v-if="loaded"
        :tags="tagItems"
        :divisions="divisions"
        :page-title="pageTitle($route) ? ucFirst(pageTitle($route)) : ''"
      />
    </tml-loader>
  </div>
</template>

<script>
import components from '../component-mixin.js';
import data from '../data-mixin.js';
import {ucFirst} from '@teemill/utilities';

export default {
  name: 'BlogDashboardPartial',

  mixins: [data, components],

  data() {
    return {
      meta: {},
    };
  },

  computed: {
    loaded() {
      return !!this.posts && !!this.tagItems;
    },
  },

  created() {
    /**
     * If the total number of posts on server is greater than the number of
     * posts in the state, assume that there are more to fetch
     */
    if (!this.total || this.posts.length < this.total) {
      this.fetchPaginatedPosts().catch(() => {});
    }
  },

  methods: {
    ucFirst,
  },
};
</script>
